// An engagement segment as flames, the marks Sales Copilot shows for the same
// segment.
//
// Copilot's `EmojiScore` is the reference, character for character: 🔥 three
// times for Very High down to once for Medium, and ❄️ for Low. The mapping is
// fixed to the segment, never derived from a score, so two leads in one
// segment cannot carry different marks.
import React from 'react';

import { segmentLabel } from './segmentVocabulary';
import './engagementFlames.css';

const FLAMES: Record<string, number> = {
  'very high': 3,
  high: 2,
  medium: 1,
  low: 0,
};

export default function EngagementFlames({
  segment,
  title,
}: {
  segment: string;
  /** Overrides the tooltip, for callers with something to add to the label. */
  title?: string;
}) {
  const label = segmentLabel('behavioral', segment);
  const count = FLAMES[segment];

  // An unknown segment shows nothing: the fit vocabulary (good, very good)
  // lands here from a lead grade matrix, and inventing a rating for it would
  // be the one failure mode nobody could spot by looking.
  if (count === undefined) return null;

  return (
    <span className="flames" title={title ?? label}>
      <span aria-hidden="true">{count ? '🔥'.repeat(count) : '❄️'}</span>
      <span className="flames-sr">{label}</span>
    </span>
  );
}
